/** @type {import('vite-plugin-pwa').Display} */
const displayMode = 'standalone'

export default displayMode
